'use client';
import dynamic from 'next/dynamic';

const ContactPage = dynamic(() => import('./ContactPage').then(mod => mod.ContactPage), {
  ssr: false,
});

const Contact = () => {
  return (
    <div>
      <ContactPage />
    </div>
  );
};
export default Contact;